import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconTypeNumberAlt = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.74423 4.09303C9.7956 3.68201 9.50406 3.30717 9.09304 3.25579C8.68203 3.20442 8.30719 3.49596 8.25581 3.90698L7.83793 7.25H4C3.58579 7.25 3.25 7.58579 3.25 8C3.25 8.41421 3.58579 8.75 4 8.75H7.65043L6.83793 15.25H4C3.58579 15.25 3.25 15.5858 3.25 16C3.25 16.4142 3.58579 16.75 4 16.75H6.65043L6.25581 19.907C6.20443 20.318 6.49598 20.6928 6.90699 20.7442C7.31801 20.7956 7.69285 20.504 7.74423 20.093L8.16211 16.75H14.6504L14.2558 19.907C14.2044 20.318 14.496 20.6928 14.907 20.7442C15.318 20.7956 15.6928 20.504 15.7442 20.093L16.1621 16.75H20C20.4142 16.75 20.75 16.4142 20.75 16C20.75 15.5858 20.4142 15.25 20 15.25H16.3496L17.1621 8.75H20C20.4142 8.75 20.75 8.41421 20.75 8C20.75 7.58579 20.4142 7.25 20 7.25H17.3496L17.7442 4.09303C17.7956 3.68202 17.5041 3.30718 17.093 3.2558C16.682 3.20442 16.3072 3.49597 16.2558 3.90698L15.8379 7.25H9.34961L9.74423 4.09303ZM9.16211 8.75L8.34961 15.25H14.8379L15.6504 8.75H9.16211Z",
		fill: "currentColor"
	})
});
export { SvgIconTypeNumberAlt as ReactComponent };
